import styled from "@emotion/styled";
import theme from "../../styles/theme";

export const QuickFactList = styled.div`
  font-size: ${theme.fontSizes[1]};
  line-height: ${theme.leading.normal};
  display: flex;
  flex-wrap: wrap;
  gap: ${theme.spacing[4]};
  color: ${theme.colors.darkBlues[75]};

  ${theme.largerThan.md} {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    gap: ${theme.spacing[8]};
  }

  ${theme.largerThan.lg} {
    font-size: ${theme.fontSizes[2]};
  }
`;

export const QuickFact = styled.div`
  display: grid;
  grid-template-columns: 30px 1fr;
  gap: ${theme.spacing[4]};

  i {
    transform: translateY(
      0.2em
    ); // adjust icons to align with text since icons do not have bounding box
  }
`;

// TODO: Fix mobile icon vertical alignment
export const IconWrapper = styled.span`
  display: block;
  width: 30px;
  height: 30px;
  border-radius: 100%;
  color: ${theme.colors.white};
  text-align: center;
  background-color: ${theme.colors.greens[100]};
`;
